module.exports = __webpack_public_path__ + "img/solution-adaptee-aux-professionnels-comme-aux-particuliers.d4eb302c.webp";